export default __webpack_public_path__ + "static/media/RFD.cda4dbc5.webp";